<mat-card appearance="outlined" fxLayout="row" fxLayoutAlign="flex-start center" class="syn-card">
    <div class="content" fxFlexOffset="10px">
        <ng-content></ng-content>
        ¯\_(ツ)_/¯
    </div>
</mat-card>
